module.exports = __webpack_public_path__ + "img/car_23.e10d95e3.jpg";